import { render, staticRenderFns } from "./SliceBodyText.vue?vue&type=template&id=734df64d&lang=pug&"
import script from "./SliceBodyText.vue?vue&type=script&lang=js&"
export * from "./SliceBodyText.vue?vue&type=script&lang=js&"
import style0 from "./SliceBodyText.vue?vue&type=style&index=0&id=734df64d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports